import { useState } from 'react'
import { faFacebook, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { faCode, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import Icon from '../Icon'
import EmbedCodeModal from './EmbedCodeModal'
import theme from '../../theme/cheddar'
import style from '../../styles/components/story/sharing-icons'

const SocialLink = ({ url, icon, title, isMobile }) => (
  <>
    <a href={url} target='_blank' title={title} className='sharing-icon' rel='noreferrer'>
      <Icon icon={icon} size={isMobile ? 'lg' : 'xl'} color={theme.colors.lightGrey} />
    </a>
    <style jsx>{style}</style>
  </>
)

const CodeEmbedButton = ({ icon, openModal, title, showModal, hasHeroVideo }) => {
  if (!hasHeroVideo) {
    return null
  }

  return (
    <>
      <div
        className='sharing-icon code-embed'
        title={title}
        onClick={(e) => {
          e.stopPropagation()
          !showModal && openModal()
        }}
      >
        <Icon icon={icon} size='xl' color={theme.colors.lightGrey} />
      </div>
      <style jsx>{style}</style>
    </>
  )
}

const SharingIcons = ({ story, hasHeroVideo, viewTranscript, setViewTranscript }) => {
  const [showModal, setShowModal] = useState(false)
  const { isMobile } = useMediaQuery()
  const { title, description, slug } = story
  const shareUrl = `https://cheddar.com/media/${slug}`
  const hasTranscript = story.videoFile && story.videoFile.transcript

  const buildSocialUrl = (base, params) =>
    base +
    '?' +
    Object.entries(params)
      .map((e) => `${e[0]}=${e[1]}`)
      .join('&')

  const facebookUrl = buildSocialUrl('https://www.facebook.com/dialog/share', {
    app_id: '1549575685346629',
    href: shareUrl,
    display: 'popup'
  })

  const linkedinUrl = buildSocialUrl('https://www.linkedin.com/shareArticle', {
    url: shareUrl,
    title,
    summary: description,
    source: 'Cheddar'
  })

  const twitterUrl = buildSocialUrl('https://twitter.com/intent/tweet', {
    url: shareUrl,
    text: title?.length <= 215 ? title : title.substring(0, 211) + '...',
    via: 'Cheddar',
    related: 'Cheddar'
  })

  const emailUrl = buildSocialUrl('mailto:', {
    subject: `${title} - Cheddar`,
    body: `${description}%0A%0A${shareUrl}`
  })

  const socialIcons = [
    { icon: faFacebook, url: facebookUrl, title: 'Share with Facebook' },
    { icon: faLinkedin, url: linkedinUrl, title: 'Share with LinkedIn' },
    { icon: faXTwitter, url: twitterUrl, title: 'Share with Twitter' },
    { icon: faEnvelope, url: emailUrl, title: 'Share with Email' },
    { icon: faCode, onClick: () => setShowModal(true), title: 'Copy embed code to clipboard' }
  ]

  return (
    <>
      <div className='share-container'>
        <div className='share-text'>Share with</div>
        <div className='sharing-icons'>
          <div className='icons'>
            {socialIcons.map(({ icon, url, onClick, title }) =>
              url ? (
                <SocialLink key={url} icon={icon} url={url} title={title} isMobile={isMobile} />
              ) : (
                <CodeEmbedButton
                  key={title}
                  hasHeroVideo={hasHeroVideo}
                  icon={icon}
                  showModal={showModal}
                  openModal={onClick}
                  title={title}
                />
              )
            )}
          </div>
          <div className={`button-container ${hasTranscript ? '' : 'hidden'}`}>
            <button onClick={() => setViewTranscript((s) => !s)}>{viewTranscript ? 'Hide Transcript' : 'View Transcript'}</button>
          </div>
          <EmbedCodeModal story={story} showModal={showModal} closeModal={() => setShowModal(false)} />
        </div>
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default SharingIcons
